import {TabState, TabStateDefaults} from 'Navigation';

export default class GridMetadataTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'grid-metadata',
    };
  }
}
